import { useEffect, useState } from "react";
import { Tabs } from "antd";
import { t } from "i18next";

import { SettingsContextProvider } from "../../modules/settings/settings.context";
import { CompanyDetails } from "./components/CompanyDetails/CompanyDetails";
import { CompanyObjects } from "./components/CompanyObjects/CompanyObjects";
import { CompanyUsers } from "./components/CompanyUsers/CompanyUsers";
import { ApiSettings } from "./components/ApiSettings/ApiSettings";
import { authService } from "../../modules/auth/auth.service";
import { UserRoles } from "../../modules/auth/auth.constants";

import style from "./SettingsPage.module.scss";

export enum SETTING_TABS {
  COMPANY_DETAILS = "company_details",
  COMPANY_OBJECTS = "company_objects",
  COMPANY_USERS = "company_users",
  API_SETTINGS = "api_settings",
}

export const SettingsPageContent = () => {
  const [defaultKey, setDefaultKey] = useState<string>(
    SETTING_TABS.COMPANY_DETAILS
  );

  const getIsVisible = (allowedRoles: UserRoles[]) =>
    authService.getRole().some((role) => allowedRoles.includes(role));

  const SETTING_TAB_CONFIG = [
    {
      key: SETTING_TABS.COMPANY_DETAILS,
      label: t("SETTINGS_COMPANY.DETALJI_KOMPANIJE"),
      children: <CompanyDetails />,
      visible: true,
    },
    {
      key: SETTING_TABS.COMPANY_OBJECTS,
      label: t("SETTINGS_COMPANY.OBJEKTI"),
      children: <CompanyObjects />,
      visible: getIsVisible([UserRoles.Obveznik, UserRoles.ObveznikObjekti]),
    },
    {
      key: SETTING_TABS.COMPANY_USERS,
      label: t("SETTINGS_COMPANY.KORISNICI"),
      children: <CompanyUsers />,
      visible: getIsVisible([
        UserRoles.Obveznik,
        UserRoles.ObveznikKorisnici,
        UserRoles.MfinKorisnici,
        UserRoles.Mfin,
      ]),
    },
    {
      key: SETTING_TABS.API_SETTINGS,
      label: t("SETTINGS_COMPANY.API"),
      children: <ApiSettings />,
      visible: getIsVisible([
        UserRoles.Obveznik,
        UserRoles.ObveznikKonfiguracija,
        UserRoles.MfinKonfiguracija,
        UserRoles.Mfin,
      ]),
    },
  ];

  const handleTabConfig = () => {
    return SETTING_TAB_CONFIG.filter((config) => config.visible);
  };

  const handleChange = (page: string) => {
    let queryParams = new URLSearchParams();
    queryParams.set("active", page);
    window.history.replaceState(null, "", "?" + queryParams.toString());
    setDefaultKey(page);
  };

  useEffect(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const activeTab = queryParams.get("active");
    if (activeTab) {
      setDefaultKey(activeTab);
    }
  }, []);

  return (
    <div className={style.container}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey={defaultKey}
        items={handleTabConfig()}
        onChange={handleChange}
        activeKey={defaultKey}
      />
    </div>
  );
};

export const SettingsPage = () => {
  return (
    <SettingsContextProvider>
      <SettingsPageContent />
    </SettingsContextProvider>
  );
};
